import { render, staticRenderFns } from "./ContactsPhones.vue?vue&type=template&id=1eca666a&"
import script from "./ContactsPhones.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsPhones.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eca666a')) {
      api.createRecord('1eca666a', component.options)
    } else {
      api.reload('1eca666a', component.options)
    }
    module.hot.accept("./ContactsPhones.vue?vue&type=template&id=1eca666a&", function () {
      api.rerender('1eca666a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsPhones.vue"
export default component.exports